module.exports = __webpack_public_path__ + "static/img/7-1.27e6bc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/7-1.jpg
// module id = UX+u
// module chunks = 0